// ─── src/api/catalystWaitlist.ts ──────────────────────────────────────────────

import { apiClient } from "./registration";
import type {
  CatalystWaitlistEntry,
  CatalystWaitlistParams,
  CatalystWaitlistResponse,
  CatalystWaitlistStats,
} from "../types/catalystWaitlist";
import type { PaginationMeta } from "../types/registration";

const BASE = "/catalyst-waitlist";

export interface NormalisedCatalystWaitlist {
  data: CatalystWaitlistEntry[];
  meta: PaginationMeta;
}

const normalise = (raw: CatalystWaitlistResponse): NormalisedCatalystWaitlist => ({
  data: raw.data,
  meta: {
    total:      raw.total,
    page:       raw.page,
    limit:      raw.limit,
    totalPages: Math.ceil(raw.total / raw.limit),
  },
});

export const getCatalystWaitlist = async (
  params: CatalystWaitlistParams,
): Promise<NormalisedCatalystWaitlist> => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null),
  );
  const { data } = await apiClient.get<CatalystWaitlistResponse>(BASE, { params: clean });
  return normalise(data);
};

export const getCatalystWaitlistStats = async (): Promise<CatalystWaitlistStats> => {
  const { data } = await apiClient.get<CatalystWaitlistStats>(`${BASE}/stats`);
  return data;
};

export const deleteCatalystWaitlistEntry = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};
